import { apiService } from '@/services/Api'
import { MktuClassWord } from '@/services/Api/generated'
import { mainStore } from '@/domains/Account/store'
import { Loader } from '@/helpers/Loader'
import { POPUP_TYPE } from '@/store/Popup'
import { makeAutoObservable } from 'mobx'
import { SEARCH_STRING_MIN_LENGTH } from '@/models/Mktu'

export class SelectWordsStore {
  originalSuggestedWords: MktuClassWord[] = []

  searchString = ''

  onlyNice = true

  suggestedWordsLoader = new Loader(
    (word: string) => this._getSuggestedWords(word),
    {
      withDebounce: true,
      debounceDelay: 800,
    }
  )

  filterClasses: MktuClassWord['classNumber'][] = []

  selectedWords: MktuClassWord[] = []

  get suggestedWords() {
    return this.onlyNice
      ? this.originalSuggestedWords.filter((w) => w.isNice)
      : this.originalSuggestedWords
  }

  get mktuNumbersList() {
    const numbers = this.suggestedWords
      .map((word) => word.classNumber)
      .sort((a, b) => a - b)

    return Array.from(new Set(numbers))
  }

  get suggestedWordsFilterByClasses() {
    if (this.filterClasses.length === 0) {
      return this.suggestedWords
    }
    return this.suggestedWords.filter((word) =>
      this.filterClasses.includes(word.classNumber)
    )
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setSearchString(word: string) {
    this.searchString = word
    this.filterClasses = []
    if (word.length >= SEARCH_STRING_MIN_LENGTH) {
      this.suggestedWordsLoader.request(word)
    } else {
      this.suggestedWordsLoader.cancel()
      this.setSuggestedWords([])
    }
  }

  setSuggestedWords(words: MktuClassWord[]) {
    this.originalSuggestedWords = words
  }

  setOnlyNice(value: boolean) {
    this.onlyNice = value
  }

  setFilterClasses(classNumber: MktuClassWord['classNumber']) {
    if (this.filterClasses.includes(classNumber)) {
      this.filterClasses = this.filterClasses.filter((c) => c !== classNumber)
    } else {
      this.filterClasses = [...this.filterClasses, classNumber]
    }
  }

  setSelectedWords(word: MktuClassWord) {
    const isContains =
      this.selectedWords.find((w) => w.uuid === word.uuid) != null

    if (isContains) {
      this.selectedWords = this.selectedWords.filter(
        (w) => w.uuid !== word.uuid
      )
    } else {
      this.selectedWords = [...this.selectedWords, word]
    }
  }

  resetAll() {
    mainStore.popup.showPopup(POPUP_TYPE.ACCEPT_POPUP, {
      onClose: (accept: boolean) => {
        if (accept) {
          this.resetSelectedWords()
        }
      },
      title: 'Сбросить выбранные слова?',
      cancelButton: 'Отмена',
      acceptButton: 'Сбросить',
    })
  }

  resetSelectedWords() {
    this.selectedWords = []
  }

  resetToDefault() {
    this.searchString = ''
    this.originalSuggestedWords = []
    this.selectedWords = []

    this.onlyNice = true
  }

  private async _getSuggestedWords(word: string) {
    const response = await apiService.mktu.getSuggestedWord({ word })
    if (
      response.status &&
      this.searchString.length >= SEARCH_STRING_MIN_LENGTH
    ) {
      this.setSuggestedWords(response.data)
    }
  }
}
